import { regex } from './regex';
export var CATCH_ALL = /[\s\S]*/; // equivalent to /.*/s, which isn't a JS standard yet
export var CATCH_ALL_AT_LEAST_ONE = /[\s\S]+/; // equivalent to /.+/s, which isn't a JS standard yet
export var IRIREF = /<[^<>\\{}|\^`\u0000-\u0020]*>/;
export var PN_CHARS_BASE = /[A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDBFF][\uDC00-\uDFFF]/;
export var LANGTAG = /@[a-zA-Z]+(-[a-zA-Z0-9]+)*/;
export var INTEGER = /\d+/;
export var DECIMAL = /(\d*\.\d+)|(\d+\.\d*)/;
export var EXPONENT = /[eE][+-]?\d+/;
export var ECHAR = /\\[tbnrf"'\\]/;
export var WS = /[\u0020\u0009\u000d\u000a]/;
export var HEX = /[0-9A-Fa-f]/;
export var PN_LOCAL_ESC = /\\[_~.\-!\$&'()*+,=\/?#@%;]/;
export var PN_CHARS_U = regex.or(PN_CHARS_BASE, /_/);
export var PN_CHARS = regex.or(PN_CHARS_U, /-/, /\d/, /\u00b7/, /[\u0300-\u036f]/, /[\u203f-\u2040]/);
export var PN_PREFIX = regex.and(PN_CHARS_BASE, regex.option(regex.and(regex.many(regex.or(PN_CHARS, /\./)), PN_CHARS)));
export var PERCENT = regex.and(/%/, HEX, HEX);
export var PLX = regex.or(PERCENT, PN_LOCAL_ESC);
export var PN_LOCAL = regex.and(regex.or(PN_CHARS_U, /:/, /\d/, PLX), regex.option(regex.and(regex.many(regex.or(PN_CHARS, /\./, /:/, PLX)), regex.or(PN_CHARS, /:/, PLX))));
export var VARNAME = regex.and(regex.or(PN_CHARS_U, /\d/), regex.many(regex.or(PN_CHARS_U, /\d/, /\u00b7/, /[\u0300-\u036f]/, /[\u203f-\u2040]/)));
export var ANON = regex.and(/\[/, regex.many(WS), /\]/);
export var NIL = regex.and(/\(/, regex.many(WS), /\)/);
export var STRING_LITERAL1 = regex.and(/'/, regex.many(regex.or(/[^\u0027\u005C\u000A\u000D]/, ECHAR)), /'/);
export var STRING_LITERAL2 = regex.and(/"/, regex.many(regex.or(/[^\u0022\u005C\u000A\u000D]/, ECHAR)), /"/);
export var STRING_LITERAL_LONG1 = regex.and(/'''/, regex.many(regex.and(regex.option(regex.or(/'/, /''/)), regex.or(/[^'\\]/, ECHAR))), /'''/);
export var STRING_LITERAL_LONG2 = regex.and(/"""/, regex.many(regex.and(regex.option(regex.or(/"/, /""/)), regex.or(/[^"\\]/, ECHAR))), /"""/);
export var DOUBLE = regex.or(regex.and(/\d+\.\d*/, EXPONENT), regex.and(/\.\d+/, EXPONENT), regex.and(/\d+/, EXPONENT));
export var INTEGER_POSITIVE = regex.and(/\+/, INTEGER);
export var DECIMAL_POSITIVE = regex.and(/\+/, DECIMAL);
export var DOUBLE_POSITIVE = regex.and(/\+/, DOUBLE);
export var INTEGER_NEGATIVE = regex.and(/-/, INTEGER);
export var DECIMAL_NEGATIVE = regex.and(/-/, DECIMAL);
export var DOUBLE_NEGATIVE = regex.and(/-/, DOUBLE);
export var VAR1 = regex.and(/\?/, VARNAME);
export var VAR2 = regex.and(/\$/, VARNAME);
export var BLANK_NODE_LABEL = regex.and(/_:/, regex.or(PN_CHARS_U, /\d/), regex.option(regex.and(regex.many(regex.or(PN_CHARS, /\./)), PN_CHARS)));
export var PNAME_NS = regex.and(regex.option(PN_PREFIX), /:/);
export var PNAME_LN = regex.and(PNAME_NS, PN_LOCAL);
